import { SET_APPEAL_REELS } from "./types"

const initialState = {
  appealReels: {
    openedInCampaignPage: [],
    openedInAmbassadorPageUserId: [],
  },
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_APPEAL_REELS:
      return {
        ...state,
        appealReels: { ...state.appealReels, ...action.payload },
      }
    default:
      return state
  }
}
export default reducer
